import React, { useEffect } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Card from './components/Card';
import Toaster from './components/Toaster';
import MainForm from './components/mainForm';

// Assuming pushToast is exported from the same file as Toaster or a utility file
import { pushToast } from './components/Toaster'; // <-- Import pushToast
import { getSsoErrorMessage } from './helpers/ssoError';

function App() {
  // Get the current location using useLocation hook
  const location = useLocation();

  // 1. Get the raw search string (e.g., "?message=hello+world&user=123")
  const searchString = location.search;

  // 2. Use URLSearchParams to parse the search string
  const queryParams = new URLSearchParams(searchString);

  // 3. Extract the specific parameter you are looking for (e.g., 'message')
  const message = queryParams.get('message');
  const errorCode = queryParams.get('errorCode');

  // 4. Extract the path without the search string for navigation (optional but helpful)
  const pathnameWithoutSearch = location.pathname.split('?')[0];

  /**
   * Use useEffect to watch for a 'message' in the URL and display the toast.
   */
  useEffect(() => {
    // Check if a message parameter exists
    const displayMessage = getSsoErrorMessage(errorCode, message);
    if (displayMessage) {
      // Call the global function to display the toast
      pushToast({
        message: displayMessage,
        type: 'error'
      });

      // Crucial: Clear the message from the URL after it has been displayed.
      // This prevents the toast from reappearing if the component re-renders.
      // It also creates a cleaner URL.
      const newLocation = `${pathnameWithoutSearch}`; // Navigate to the same path, but without the query
      window.history.replaceState({}, document.title, newLocation);
    }
  }, [message, errorCode, pathnameWithoutSearch]); // Rerun when 'message' or path changes

  return (
    <>
      <div className="guide">
        <Card>
          <Routes>
            <Route exact path="/:page" element={<MainForm />} />
            {/* Use Navigate inside a Route */}
            <Route
              path="/"
              // Corrected Navigate: only redirect to /login, the useEffect handles the message
              // The message should be cleared by the useEffect's replaceState.
              element={<Navigate to={`/login`} />}
            />
          </Routes>
        </Card>
      </div>
      {/* The Toaster component should generally be rendered without props, 
        as it subscribes to the global toastSubject internally.
      */}
      <Toaster />
    </>
  );
}

export default App;
